<template>
  <div>
    <el-dialog
      title="编辑资源拓展"
      :visible.sync="flag"
      width="70%"
      @close="onClose"
      v-if="flag"
    >
      <wedit v-if="flag" v-model="materialExpand"></wedit>
      <span slot="footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="onClick" :loading="loading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import wedit from "@/components/wedit";
import {aesDecrypt} from "../../../utils";
export default {
  components: { wedit },
  data() {
    return {
      flag: false,
      id: "",
      materialExpand: "",
      loading: false,
    };
  },
  methods: {
    open(id) {
      this.$http({
        url: this.$http.adornUrl(`/course/course/info/${id}`),
        method: "get",
        params: this.$http.adornParams(),
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            let courseStr = aesDecrypt(data.course, "af8a6575c1");
            let course = JSON.parse(courseStr);
            data.course = course;
            this.flag = true;
            this.id = data.course.id;
            this.materialExpand = data.course.materialExpand || "";
          } else {
            this.$message.error("获取资料拓展失败");
          }
        })
        .catch(() => {
          this.$message.error("获取资料拓展失败");
        });
    },
    onClick() {
      this.loading = true;
      this.$http({
        url: this.$http.adornUrl("course/course/update"),
        method: "put",
        data: this.$http.adornData({
          id: this.id,
          materialExpand: this.materialExpand,
        }),
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.flag = false;
            this.$emit("refreshDataList");
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onClose() {
      this.flag = false;
      this.id = "";
      this.materialExpand = "";
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
